import getConnectionType from '../getters/get-connection-type';
import getBatteryLevel from '../getters/get-battery-level';
import { getISOTime } from '../getters/get-time-stamp';
import { trimByLength } from '../helpers/trim-by-length';
import { prepareProperties } from '../helpers/prepare-properties';
import { getCurrentTitle, getCurrentURL } from '../helpers/get-document-data';
import { getProfile } from './profile';
import { getMeta } from './meta';
import { getDeviceId } from './device-id';
import { getSessionId, setSessionId } from './session-id';
const EVENT_ACTION_LENGTH = 1024;
const getData = async (event, eventType, options) => {
  const url = options?.url ?? getCurrentURL();
  const pageName = getCurrentTitle();
  let batteryLevel;
  if (document.visibilityState !== 'hidden') {
    batteryLevel = await getBatteryLevel();
  }
  return {
    eventCategory: trimByLength(event.eventCategory),
    eventAction: trimByLength(event.eventAction, EVENT_ACTION_LENGTH),
    eventType,
    value: trimByLength(event.value),
    properties: prepareProperties(event.properties),
    batteryLevel,
    connectionType: getConnectionType(),
    timeStamp: options?.timeStamp || getISOTime(),
    ...(url && {
      url: trimByLength(url)
    }),
    ...(pageName && {
      pageName: trimByLength(pageName)
    })
  };
};
export const getEventData = async (event, eventType, options) => {
  // Пакет с событием ожидает deviceId и sessionId, но если не передали, то он самостоятельно создаст информацию о них
  let deviceId = options?.deviceId;
  let sessionId = options?.sessionId;
  if (!deviceId) {
    deviceId = await getDeviceId();
  }
  if (!sessionId) {
    await setSessionId();
    sessionId = getSessionId();
  }
  const profile = await getProfile({
    sessionId,
    deviceId
  });
  const meta = getMeta();
  const dataItem = await getData(event, eventType, options);
  return {
    profile,
    meta,
    data: [dataItem]
  };
};